import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';

import MetricsEditBaseRoute from 'webapp/routes/metrics/edit/base';

import type { Script } from 'webapp/models-custom';

export default class MetricsEditCalculatedRoute extends MetricsEditBaseRoute<Script> {
	@service('model-manager/scripts')
	declare mmScriptService: Service.ModelManager.Scripts;

	protected readonly notFoundText =
		'Custom metric does not exist or you do not have permissions to customize it.';
	protected readonly billingFeature = BillingFeature.SCRIPTS;

	override model(params: { script_id: string }): Script | null {
		return this.mmScriptService.findModel(params.script_id);
	}

	protected openEditPopup(model: Script) {
		return this.mmScriptService.openEditPopup(model, 'metrics');
	}
}
